import React from "react";
import { Box, Typography, styled } from "@mui/material";
import { primary, theme } from "../../../constants/theme";

const CustomHeaderDesc = styled(Box)(({ theme }) => ({
  width: "82%",
  margin: "0 auto",
  padding: "36px 0",
  ".banner-container": {
    margin: "auto",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    padding: "0 12px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: "0 12px",
    ".banner-container": {
      width: "100%",
      padding: "0 12px",
    },
  },
}));
const ProductTopBanner = ({ location = "India", vehicle_name }) => {
  return (
    <CustomHeaderDesc>
      <Box style={{}} className="banner-container">
        <Typography variant="h1" style={{ fontSize: "42px", fontWeight: "700" }}> 
           {vehicle_name}
        </Typography>
      </Box>
    </CustomHeaderDesc>
  );
};

export default ProductTopBanner;
